import { useTranslation } from "react-i18next";
import CustomSharedConfirmationModal from "sipli-fleet-core/components/CustomSharedConfirmationModal/CustomSharedConfirmationModal";

interface CustomerTypeDeleteProps {
  open: boolean;
  isLoading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const CustomerTypeDelete = ({ open, isLoading, onCancel, onConfirm }: CustomerTypeDeleteProps) => {
  const { t } = useTranslation();
  return (
    <CustomSharedConfirmationModal
      open={open}
      title={`${t("delete")} ${t("customer_type")}`}
      description={t("delete_resource_description", { name: t("customer_type") })}
      confirmText={t("delete")}
      cancelText={t("cancel")}
      isLoading={isLoading}
      onCancel={onCancel}
      onConfirm={onConfirm}
      centered
    />
  );
};

export default CustomerTypeDelete;
